module.exports = __webpack_public_path__ + "img/glm_gbt6170_2000.prt.d40fbe69.jpg";